import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { withAuthenticationRequired } from '@auth0/auth0-react';


import { useAppDispatch } from 'shared/hooks/useAppDispatch';
import { AuthLayout } from 'shared/components/AuthLayout';
import { useAccounts } from 'shared/store/modules/accounts/hooks';
import { useAuth0Session } from 'shared/store/modules/auth/hooks';
import { fetchAccounts } from 'shared/store/modules/accounts/effects';
import Loading from 'shared/components/Loading';

function AccountPickerContainer() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { accounts, setActiveAccountId } = useAccounts();
  const { isAdmin } = useAuth0Session();
  const [isLoading, setIsLoading] = useState(false);

  function handleClick(accountId: string) {
    setActiveAccountId(accountId);
    history.push('/');
  }

  if (isAdmin()) {
    history.push('/admin');
  }

  if (accounts.length === 1) {
    handleClick(accounts[0].id);
  }

  useEffect(() => {
    if (!isLoading) {
      setIsLoading(true);

      dispatch(fetchAccounts())
        .finally(() => {
            setIsLoading(false)
        });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <AuthLayout title="Login">
      <p className="text-center font-weigh-bold">Select an Account</p>

      {isLoading ? (
        <Loading />
      ) : (
        <ListGroup>
          {accounts.map(account => (
            <ListGroupItem action key={account.id} onClick={() => handleClick(account.id)} tag="button">
              {account.name}
            </ListGroupItem>
          ))}
        </ListGroup>
      )}

      <small className="d-block text-center mt-3">
        <Link to="/logout">Sign out</Link>
      </small>
    </AuthLayout>
  );
}

export const AccountPicker = withAuthenticationRequired(AccountPickerContainer);
